import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "AddOn";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Things sold alongside a ticket. */
export const AddOnService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),
	getAll: async () => await FetchInterceptor(url(""), {headers: json, method: "GET"}),
	add: async (data: any) => await FetchInterceptor(url(""), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) => await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"}),
	/** Storefront: the slug carries the tenant, since this is anonymous. */
	forProduct: async (clubSlug: string, productType: number, productId: number) =>
		await FetchInterceptor(url(`/For/${encodeURIComponent(clubSlug)}/${productType}/${productId}`), {headers: json, method: "GET"})
}
